var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.3551V18.4801H5.625L14.8417 9.26343L11.7167 6.13843L2.5 15.3551ZM17.2583 6.84677C17.5833 6.52176 17.5833 5.99677 17.2583 5.67177L15.3083 3.72177C15.2312 3.6445 15.1397 3.5832 15.0389 3.54138C14.938 3.49956 14.83 3.47803 14.7208 3.47803C14.6117 3.47803 14.5036 3.49956 14.4028 3.54138C14.302 3.5832 14.2104 3.6445 14.1333 3.72177L12.6083 5.24677L15.7333 8.37176L17.2583 6.84677Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ee2a57cf87999b407712911465df66df.svg";
export { ForwardRef as ReactComponent };